
<ng-container [formGroup]="formGroup">
    <h2 class="mb-0" mat-dialog-title>Unesite rok za izvršenje</h2>
    <div class="col-md-12 no-padding">
        <div class="col-md-5 no-padding">

            <input class="form-control no-border form-control-sm form-control-group"
                   placeholder="Izaberite datum"
                   name="dp"
                   style="margin-top: 25px"
                   (click)="d.toggle()"
                   formControlName="date"
                   [formControl]="date"
                   [(ngModel)]="selected"
                   ngbDatepicker #d="ngbDatepicker">

        </div>

        <div class="col-md-7 no-padding">

            <ngb-timepicker [(ngModel)]="time1"
                            formControlName="time"
            ></ngb-timepicker>
        </div>
        <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
             *ngIf="(formGroup.get('time').invalid || formGroup.get('date').invalid)">Ovo polje je obavezno.
        </div>
    </div>
    <div class="col-md-12" style="
    display: flow-root;
" mat-dialog-actions>
        <button mat-button class="float-right" (click)="close()">Otkaži</button>
        <button mat-button class="float-right" (click)="save()">Sačuvaj</button>
    </div>
</ng-container>
